export enum SexEnum {
    MEN = 'H',
    WOMEN = 'F',
}
